import { Observable } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';

import { QuickstartProgrammingService } from '../../services/quickstart-programming.service';
import { SharedProgrammingService } from './../../../common/services/shared-programming.service';
import { ScheduleQuickstartContext, ScheduleEvent } from './../services/schedule.service';
import { BaseRoutingComponent } from '../../../common/base-routing/base-routing.component';
import { ScheduleProgrammingService } from '../services/schedule.service';
import { ProgrammingUtilsService as Utils } from './../../../common/services/utils.service';

@Component({
  selector: 'prg-add-schedule',
  templateUrl: './add-schedule.component.html',
  styleUrls: ['./add-schedule.component.less']
})
export class AddScheduleComponent extends BaseRoutingComponent implements OnInit {

  errors: Observable<Array<any>>;
  context: Observable<ScheduleQuickstartContext>;
  event: Observable<ScheduleEvent>;

  constructor(
    protected router: Router,
    private route: ActivatedRoute,
    protected store: Store<any>,
    private quickstarts: QuickstartProgrammingService,
    private shared: SharedProgrammingService,
    private schedule: ScheduleProgrammingService
  ) {
    super();
    this.context = this.store.select(s => s.scheduleProgramming);
    this.errors = this.store.select(s => s.scheduleProgramming.validationErrors);
    this.event = this.store.select(s => s.scheduleProgramming.event);
  }

  ngOnInit() {
    this.schedule.clearSchedule();
    // this.shared.addBreadcrumb({ label: 'Create', route: Utils.getPathFromRoot(this.route) });
  }

  private _createSchedule() {
    if (this.schedule.validate()) {
      // NOTE this is required to setup a blank schedule event since they are not created until programming is added
      this.shared.setSelectedEvent(this.schedule.buildEvent());

      this.store.select(s => s.sharedProgramming.trigger.event).filter(e => !!e).distinctUntilChanged().subscribe(e => {
        console.log('add-sched: trigger event changed', e);
        if (e.deviceId === 100100 && e.eventId === 0) {
          this.router.navigate(['when-then/device/100100/event/0/add'], { relativeTo: this.moduleRoot });
        }
      });
    } else {
      console.warn('schedule is invalid');
    }
  }

  validateAndCreate() {
    // TODO name is required
    this._createSchedule();
  }

  setName(event: any) {
    this.schedule.setName(event.target.value);
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-schedule/add-schedule/add-schedule.component.ts